'use client'

import { useHyperliquidAutoDeposit } from '@/hooks/useHyperliquidAutoDeposit'
import { useHyperliquidBridgeWatcher } from '@/hooks/useHyperliquidBridgeWatcher'
import { useHyperliquidSettlements } from '@/hooks/useHyperliquidSettlements'
import { useHyperliquidUserEvents } from '@/hooks/useHyperliquidUserEvents'

/**
 * Mounts the global Hyperliquid side-effect watchers at the app root:
 *  - auto-deposit (Arbitrum USDC → HyperCore via Bridge2 transfer)
 *  - settlements (toast on outcome resolve + PnL credit)
 *  - userEvents WS (toast on fills + cache invalidation)
 *
 * Returns null — no UI, all side-effects.
 */
export function HyperliquidAutoDepositMount() {
	useHyperliquidAutoDeposit()
	useHyperliquidBridgeWatcher()
	useHyperliquidSettlements()
	useHyperliquidUserEvents()
	return null
}
